import { ArrowLeftIcon, FileSearch2Icon } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateHeading,
  EmptyStateIcon,
} from "@/components/ui/empty-state";
import { Link } from "@/components/ui/link";
import { cn } from "@/components/ui/utils";
import type { BillingDetailTab } from "./BillingDetailShell";

type BillingRecordNotFoundProps = {
  resourceLabel: string;
  resourceId: number;
  billingTab: BillingDetailTab;
};

export function BillingRecordNotFound({
  resourceLabel,
  resourceId,
  billingTab,
}: BillingRecordNotFoundProps) {
  const listLabel =
    billingTab === "master-invoices" ? "Master invoices" : "Invoices";

  return (
    <div className="flex flex-1 min-h-0 flex-col overflow-hidden rounded-lg border bg-background shadow-xs">
      <EmptyState className="min-h-[min(420px,70vh)] py-16 md:py-24">
        <EmptyStateIcon>
          <FileSearch2Icon className="size-12 stroke-[1.25]" aria-hidden />
        </EmptyStateIcon>
        <EmptyStateHeading>{resourceLabel} not found</EmptyStateHeading>
        <EmptyStateDescription>
          No {resourceLabel.toLowerCase()} exists with ID{" "}
          <span className="font-medium text-foreground tabular-nums">
            {resourceId}
          </span>
          . It may have been removed, or this link may be out of date. Open the
          record from the {listLabel.toLowerCase()} list to be sure you have the
          latest ID.
        </EmptyStateDescription>
        <EmptyStateActions>
          <Link
            href={{ to: "/admin/billing", search: { t: billingTab } }}
            className={cn(
              buttonVariants({ variant: "default", size: "default" }),
              "gap-2",
            )}
          >
            <ArrowLeftIcon className="opacity-70" aria-hidden />
            Back to {listLabel}
          </Link>
        </EmptyStateActions>
      </EmptyState>
    </div>
  );
}
